import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#4a5568',
      contrastText: '#fff',
    },
    secondary: {
      main: '#F3F2F1',
      contrastText: '#4a5568',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});
